<script lang="ts">
  import type { HTMLSelectAttributes } from "svelte/elements";
  import { cn } from "$lib/utils/cn";
  import { fieldStateClass, fieldStateFocusRing, type FormFieldState } from "./fieldState";

  type Option = { value: string; label: string };

  type Props = Omit<HTMLSelectAttributes, "value"> & {
    class?: string;
    invalid?: boolean;
    /** @deprecated Prefer `state="filled"`. */
    autofilled?: boolean;
    state?: FormFieldState;
    value?: string;
    options?: Option[];
    placeholder?: string;
  };

  let {
    class: className,
    invalid = false,
    autofilled = false,
    state,
    value = $bindable(""),
    options = [],
    placeholder,
    children,
    ...rest
  }: Props & { children?: import("svelte").Snippet } = $props();

  const visualState = $derived(state ?? (invalid ? "invalid" : autofilled ? "filled" : "default"));
</script>

<select
  bind:value
  class={cn(
    "surface-input",
    "h-10 w-full rounded-md px-3 text-sm",
    "transition-[border-color,box-shadow,background-color] duration-fast ease-standard",
    "focus:outline-none focus:ring-2",
    fieldStateFocusRing(visualState, invalid),
    fieldStateClass(visualState, { invalid, autofilled }),
    "disabled:opacity-60 disabled:cursor-not-allowed",
    className,
  )}
  aria-invalid={visualState === "invalid" || invalid || undefined}
  {...rest}
>
  {#if placeholder}
    <option value="" disabled={rest.required}>{placeholder}</option>
  {/if}
  {#if children}
    {@render children()}
  {:else}
    {#each options as opt (opt.value)}
      <option value={opt.value}>{opt.label}</option>
    {/each}
  {/if}
</select>
